import { AppBar, Container, Toolbar, Box, Button, Stack } from '@mui/material';
import React, { ReactNode } from 'react';
import AppCustomIcon from '../features/icon/AppIcon';
import { AppLogoTextWhite } from '../features/logo/AppLogo';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import AppLangSelect from '../features/lang/features/select/AppLangSelect';
import { useTranslation } from 'react-i18next';
import appLayoutLang from '../langs/appLayoutLang';

type LAppPublicProps = {
	children: ReactNode;
};
const LAppPublic = (props: LAppPublicProps) => {
	const navigate = useNavigate();
	const { t } = useTranslation();
	return (
		<>
			<AppBar position="sticky">
				<Container maxWidth="xl">
					<Toolbar disableGutters>
						<Box sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }}>
							<Link to="/">
								<AppLogoTextWhite style={{ height: '50px' }} />
							</Link>
						</Box>
						<Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }} />
						<Box sx={{ flexGrow: 0 }}>
							<Stack direction="row" alignItems="center" justifyContent="center">
								<AppLangSelect style={{ color: '#FFF' }} />
								<Button
									onClick={() => {
										navigate('/');
									}}
									sx={{ my: 2, color: 'white', display: 'block' }}
								>
									<Stack direction="row" alignItems="center" justifyContent="center">
										{t(appLayoutLang.btn_back_to_irp.tag)}{' '}
										<AppCustomIcon tag="arrow-right" style={{ marginLeft: '10px' }} />
									</Stack>
								</Button>
							</Stack>
						</Box>
					</Toolbar>
				</Container>
			</AppBar>

			<Container sx={{ paddingTop: '30px' }}>{props.children}</Container>
		</>
	);
};

export default LAppPublic;
